export default __webpack_public_path__ + "133902776df2bdfc3114a092496e24c5.png";